"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowStateController = void 0;
const enums_convertors_1 = require("../utils/enums_convertors");
/** @internal */
class WindowStateController {
    constructor(window) {
        // ---------------------------------------------------------------------------
        this.onWindowStateChanged = (args) => {
            if (args.window_id !== this.window.Id()) {
                return;
            }
            if ("closed" /* closed */ === args.window_state_ex) {
                this.window.onWindowClosed();
                return;
            }
            if (args.window_state_ex !== args.window_previous_state_ex) {
                this.raiseWindowStateEvent(args);
            }
        };
        this.window = window;
        overwolf.windows.onStateChanged.addListener(this.onWindowStateChanged);
    }
    // ---------------------------------------------------------------------------
    raiseWindowStateEvent(args) {
        if (this.window.windowInfo) {
            this.window.windowInfo.stateEx = args.window_state_ex;
        }
        const newState = enums_convertors_1.EnumConvertors.ToWindowState(args.window_state_ex);
        const prevState = enums_convertors_1.EnumConvertors.ToWindowState(args.window_previous_state_ex);
        switch (args.window_state_ex) {
            case "minimized" /* minimized */: {
                this.window.fire('minimized', newState, prevState);
                break;
            }
            case "maximized" /* maximized */: {
                this.window.fire('maximized', newState, prevState);
                break;
            }
            case "hidden" /* hidden */: {
                this.window.fire('hide', newState, prevState);
                break;
            }
            case "normal" /* normal */: {
                if (args.window_previous_state_ex ===
                    "hidden" /* hidden */) {
                    this.window.fire('show', newState, prevState);
                }
                else {
                    this.window.fire('restore', newState, prevState);
                }
                break;
            }
            default:
                console.error(`window state changed: unknown state ${args.window_state_ex}`);
        }
    }
    // ---------------------------------------------------------------------------
    dispose() {
        overwolf.windows.onStateChanged.removeListener(this.onWindowStateChanged);
        this.window = null;
    }
}
exports.WindowStateController = WindowStateController;
//# sourceMappingURL=window_state_controller.js.map